import React from 'react';

const PurchaseStatesPage = () => {
  return (
    <div className="purchase-states-page">
      <div className="page-header">
        <h1>Purchase State Access</h1>
        <p>Expand your quiz library by purchasing access to additional states.</p>
      </div>
      
      <div className="states-grid">
        <div className="coming-soon-card">
          <h3>State Purchases Coming Soon</h3>
          <p>
            We're working on making additional state content available for purchase. 
            Check back soon for more quiz options!
          </p>
        </div>
      </div>
    </div>
  );
};

export default PurchaseStatesPage;